'use strict';

/**
 * @param    { String }    pattern    pattern like user[firstname]
 * @param    { Object }    state      form state or data (with the trailing first bracket)
 *
 * @return   { Object }
 **/
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFormJSON;
function getFormJSON(_ref) {
  let {
    form_data,
    pattern = '',
    state
  } = _ref;
  form_data = form_data || {};
  Object.keys(state).filter(prop => pattern ? prop.indexOf(pattern) === 0 : true).forEach(function (prop) {
    const element = state[prop];
    parse(element, prop);
  });
  return form_data;
  function parseObject(object, base) {
    Object.keys(object).forEach(function (prop) {
      const pattern = base + '[' + prop + ']';
      const element = object[prop];
      parse(element, pattern);
    });
  }
  function parseArray(array, base) {
    array.forEach(function (element, i) {
      const pattern = base + '[' + i + ']';
      parse(element, pattern);
    });
  }
  function parse(element, pattern) {
    if (Array.isArray(element)) {
      parseArray(element, pattern);
    } else if (element && typeof element === 'object') {
      parseObject(element, pattern);
    } else if (typeof element !== 'undefined') {
      if (['true', 'false'].includes(element)) {
        form_data[pattern] = [true, 'true'].includes(element);
      } else {
        form_data[pattern] = element;
      }
    }
  }
}
